export default "__VITE_ASSET__BrfY8sTR__"